/**
 * Zone-timed ambience one-shots.
 */
export class mt {
        sfx;
        onGust;
        timers;
        t = 0;
        constructor(e, t) {
            this.sfx = e, this.onGust = t;
            let n = (e, t, n, r) => {
                let i = Math.random() * Math.PI * 2,
                    a = t + Math.random() * (n - t);
                return {
                    x: e.x + Math.sin(i) * a,
                    y: r,
                    z: e.z + Math.cos(i) * a
                }
            };
            this.timers = [{
                zone: `forest`,
                next: 9,
                min: 20,
                max: 45,
                fire: e => this.sfx.owl(n(e, 26, 45, 10))
            }, {
                zone: `forest`,
                next: 5,
                min: 8,
                max: 18,
                fire: e => this.sfx.twig(n(e, 7, 16, .3))
            }, {
                zone: `forest`,
                next: 14,
                min: 10,
                max: 24,
                fire: e => this.sfx.creak(n(e, 6, 14, 6))
            }, {
                zone: `forest`,
                next: 22,
                min: 16,
                max: 32,
                fire: () => {
                    let e = .5 + Math.random() * .5;
                    this.sfx.gust(e), this.onGust(e, 6)
                }
            }, {
                zone: `pipe`,
                next: 6,
                min: 14,
                max: 30,
                fire: e => this.sfx.clank({
                    x: (Math.random() - .5) * 2,
                    y: 1,
                    z: e.z + (Math.random() < .6 ? 1 : -1) * (12 + Math.random() * 18)
                })
            }]
        }
        update(e, t, n) {
            this.t += e;
            for (let e of this.timers) {
                if (e.zone !== n) {
                    e.next < this.t + 3 && (e.next = this.t + 3 + Math.random() * 4);
                    continue
                }
                this.t < e.next || (e.next = this.t + e.min + Math.random() * (e.max - e.min), e.fire(t))
            }
        }
}

export { mt as Ambience };
